export const sanitizeReturnPath = (value: unknown, fallback: string): string => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return fallback;
  try {
    const parsed = new URL(value, 'https://local.invalid');
    const fallbackURL = new URL(fallback, 'https://local.invalid');
    if (parsed.origin !== fallbackURL.origin || parsed.pathname !== fallbackURL.pathname) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
};

const playerReportPath = /^\/(players|scouting)\/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$/i;

export const parsePlayerReportReturnPath = (value: unknown, fallback = '/reports'): string => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return fallback;
  try {
    const parsed = new URL(value, 'https://local.invalid');
    if (parsed.origin !== 'https://local.invalid' || parsed.hash || !playerReportPath.test(parsed.pathname)) return fallback;
    if (Array.from(parsed.searchParams.keys()).length !== 1 || parsed.searchParams.get('tab') !== 'reports') return fallback;
    return `${parsed.pathname}?tab=reports`;
  } catch {
    return fallback;
  }
};

export const detailLocation = (pathname: string, browseLocation: string) => ({
  pathname,
  state: { from: browseLocation },
});
